import React from 'react';

import LocaleContext from './LocaleContext';
import { LocaleContextProviderProps } from './LocaleProvider.types';

class LocaleContextProvider extends React.PureComponent<LocaleContextProviderProps> {
  render() {
    const { children, intl, ...rest } = this.props;

    return (
      <LocaleContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          ...rest,
          formatMessage: intl.formatMessage,
        }}
      >
        {children}
      </LocaleContext.Provider>
    );
  }
}

export default LocaleContextProvider;
